import React from "react";
import RegionalAnalyticsPage from "../../../entities/SuperAdminPage/RegionalAnalytics";

const RegionalAnalytics = () => {
  return <RegionalAnalyticsPage />;
};

export default RegionalAnalytics;